<template>
	<div class="CaretUp svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1698636372594" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4046" :width="size" :height="size">
			<path d="M960 704L512 256l-448 448z" fill="#262626" p-id="4047"></path>
		</svg>
	</div>
</template>
<script setup name="CaretUp">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 16
		}
	})
</script>
<style scoped lang="less">
	.CaretUp,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
